export const environment = {
  defaultLang: 'en',
  policyUrl: '#',
  guideLink: '../assets/pdf/Guide.pdf',

  pocketBase: {
    url: 'https://faber-pocketbase.gkops.net',
  },

  supportEmail: 'example@email.com',
};
